<div class="main-cont">
  <header class="main-header ">
    <div class="headerInn position-relative">
      <div class="logo_wrap">
        <div class="triangle-up"></div>
        <div class="logo-bg">
          <a href="" class="main-logo">
            <picture class="w-100 d-block">
              <source srcset="assets/ITI-IAP-HTML/images/siteLogo.svg" media="(min-width: 768px)" class="w-100 deskImg">
              <img decoding="async" src="assets/ITI-IAP-HTML/images/siteLogo.svg" alt="" class="w-100 mobImg"
                loading="lazy">
            </picture>
          </a>
        </div>
      </div>
      <div class="header-one">
        <div class="full-container container lg-container-vw">
          <div class="row row-vw">
            <div class="col-lg-3"></div>
            <div class="col-lg-9">
              <div class="backtoHome_btn text-end">
                <a (click)="backToHome()" class="bkto-home f-s-14 text-white">Back to Home ></a>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header-two">
        <div class="full-container container lg-container-vw">
          <div class="row row-vw">
            <div class="col-lg-3"></div>
            <div class="col-lg-9">
              <nav class="navbar navbar-expand-lg cstNavbar">
                <div class="collapse navbar-collapse justify-content-end" id="collapsibleManiNav">
                  <div class="navMng-In">

                    <ul class="navbar-nav cstNav ms-auto">
                      <li class="d-lg-none d-block mrg-b-20">
                        <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapsibleManiNav">
                          <span class="navbar-toggler-icon"></span>
                        </button>
                      </li>
                      <li class="nav-item cursor-pointer">
                        <a class="nav-link f-s-16 f-w-M" (click)="goToSection('introduction')"> Introduction </a>
                      </li>
                      <li class="nav-item cursor-pointer">
                        <a class="nav-link f-s-16 f-w-M" (click)="goToSection('why-invest')"> Why Invest </a>
                      </li>
                      <li class="nav-item cursor-pointer">
                        <a class="nav-link f-s-16 f-w-M" (click)="goToSection('why-consistency')"> Why Consistency </a>
                      </li>
                      <li class="nav-item cursor-pointer">
                        <a class="nav-link f-s-16 f-w-M" (click)="goToSection('know-more')">Know More </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapsibleManiNav">
                  <span class="navbar-toggler-icon"></span>
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <div id="carouselExampleIndicators" class="carousel slide custom-carousel carousel-fade" data-ride="carousel">
    <ol class="carousel-indicators">
      <li *ngFor="let banner of BannerList; index as i" [class.active]="i === 0"
        data-target="#carouselExampleIndicators" [attr.data-slide-to]="i">
      </li>
    </ol>
    <div class="carousel-inner">
      <div *ngFor="let banner of BannerList; index as i" class="carousel-item" [class.active]="i === 0">
        <!-- <img class="img-responsive bnr-img-home" [src]="banner.webBannerImagePath" [alt]="banner.alt"> -->
        <picture class="w-100 d-block" (click)="viewClickableUrlPage(banner.clickableUrl)">
          <source [srcset]="banner.webBannerImagePath" media="(min-width: 768px)" class="w-100 deskImg">
          <img decoding="async" [src]="banner.mobileBannerImagePath" alt="" class="img-responsive bnr-img-home"
            loading="lazy">
        </picture>
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
      <div class="circle"> <span class="carousel-control-prev-icon" aria-hidden="true"></span></div>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
      <div class="circle"> <span class="carousel-control-next-icon" aria-hidden="true"></span></div>
      <span class="sr-only">Next</span>
    </a>
  </div>

  <div class="secWrap" id="introduction" >
    <div class="full-container container lg-container-vw">
      <div class="row row-vw justify-content-center" *ngIf="organizedSections && organizedSections['Section1']">
        <div class="col-lg-12">
          <div class="secHeader text-center mrg-b-30">
            <!-- <div class="sectitle f-s-36 mrg-b-15"> <span class="clr-red">Decoding SIP:</span> Everything You Need to
              Know Before Investing </div> -->
              <div class="sectitle f-s-36 mrg-b-15">{{  organizedSections['Section1']?.title }}  </div>
            <div class="secSub-title">
              {{  organizedSections['Section1']?.description }} 
            </div>
          </div>
        </div>
      </div>
      <div class="row row-vw">

        <div class="col-lg-12">
          <ul class="nav nav-pills justify-content-center align-items-end cstTabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="watch-tab" data-toggle="tab" href="#watch-tab-pane" role="tab"
                aria-controls="watch-tab-pane" aria-selected="true" (click)="onTabChange('watch')">Watch</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="nfographics-tab" data-toggle="tab" href="#infographics-tab-pane" role="tab"
                aria-controls="infographics-tab-pane" aria-selected="false"
                (click)="onTabChange('infographics')">Infographics</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="read-tab" data-toggle="tab" href="#read-tab-pane" role="tab"
                aria-controls="read-tab-pane" aria-selected="false" (click)="onTabChange('read')">Read</a>
            </li>
          </ul>
          <div class="arrow-btn-row">
          <div class="arrow-img cursor-pointer" [ngClass]="{ 'invisible': !showArrow }" (click)="scrollLeft()"><img
                src="assets/ITI-IAP-HTML/images/chevron-left.svg" alt="" srcset="">
         
            </div>
            <div class="tab-content accordion" id="myTabContent">
              <div class="tab-pane fade show active" id="watch-tab-pane" role="tabpanel" aria-labelledby="watch-tab"
                tabindex="0" *ngIf="activeTab === 'watch'">
                <div class="accordion-body tabOverview_wrap"
                  *ngIf=" videoList && videoList.length>0; else noVideoTemplate">
                  <div class="row row-vw blogs-row" #videoRow>
                    <div class="col-lg-4" *ngFor="let video of videoList">
                      <div class="watchBx">
                        <div target="_blank" class="watchBx-link d-block" (click)="openVideo(video.youtubeLink)">
                          <div class="yt-img position-relative mrg-b-15 cursor-pointer">
                            <picture class="w-100 d-block infographic">
                              <!-- tumbnail for desktop when the screen wider than 768px -->
                              <source [srcset]="video.imagePath" class="w-100 deskImg  thumbnail-img"
                                media="(min-width: 768px)">
                              <!--tumbnail for mobiles  -->
                              <img [src]="video.imagePath" alt="Video Thumbnail" class="w-100 mobImg thumbnail-img"
                                loading="lazy">
                            </picture>
                            <div class="playIcon">
                              <img src="assets/ITI-IAP-HTML/images/play-icon.png" class="w-100" alt="Play Icon">
                            </div>
                          </div>
                          <div class="watchTitle f-s-20  line_H_1_2 text-black text-decoration-underline " style="text-align: center;">
                            {{ video.title }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row row-vw">
                    <div class="col-lg-12">
                      <div class="viewAll_wrap mrg-t-50 text-center" (click)="viewAllBlogs()">
                        <a class="viewAll_btn f-s-20 font-Baskervville "> View All </a>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #noVideoTemplate>

                  <p class="nodata">No Videos found.</p>


                </ng-template>
              </div>


              <div class="tab-pane fade" id="infographics-tab-pane" role="tabpanel" aria-labelledby="infographics-tab"
                tabindex="0" *ngIf="activeTab === 'infographics'">
                <div class="accordion-body tabOverview_wrap"
                  *ngIf="infographicList && infographicList.length>0; else noInfographicTemplate">
                  <div class="row row-vw blogs-row" #infoRow>
                    <div class="col-lg-4" *ngFor="let infographic of infographicList">
                      <div class="watchBx">
                        <div class="yt-img position-relative mrg-b-15 cursor-pointer" (click)="openModal(content)">

                          <picture class="w-100 d-block infographic">
                            <source [srcset]="infographic.thumbnailPath" media="(min-width: 768px)"
                              class="w-100 deskImg image-fit thumbnail-img">
                            <img decoding="async" [src]="infographic.thumbnailPath" [alt]="infographic.thumbnailName"
                              class="w-100 mobImg image-fit thumbnail-img" loading="lazy">
                          </picture>

                        </div>
                        <div class="infoGraph">
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="shareBtn_wrap">
                              <ul class="list-inline mb-0">
                                <li class="list-inline-item">
                                  <div class="shareBtn line_H_1 text-black f-s-14 d-flex cstgap-2">
                                    Share <img src="assets/ITI-IAP-HTML/images/share-icon.svg" class="shareIcon" alt=""
                                      loading="lazy">
                                  </div>
                                </li>
                                <li class="list-inline-item" *ngFor="let shareIcon of [1, 2, 3, 4]">
                                  <a href="javascript:void(0);"
                                  class="shareIcon"
                                  (click)="
                                    redirectToSocialMedia(
                                      shareIcon,
                                      infographic.filePath
                                    )
                                  ">
                                    <img [src]="'assets/ITI-IAP-HTML/images/share-icon-' + shareIcon + '.svg'"
                                      class="w-100" alt="" loading="lazy">
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div class="downloadBtn-wrap">
                              <a href="javascript:void(0);" class="downloadBtn line_H_1 text-black f-s-14 d-flex cstgap-2" (click)="downloadFile(infographic.filePath)">
                                Download  <file-download [path]="infographic.filePath"></file-download>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ng-template #content let-modal>
                        <div class="closeBtn" (click)="closePopup(modal)">
                          <img class="btn-close" src="assets/ITI-IAP-HTML/images/black-close-circle-or-delete-20709.svg"
                            alt="" srcset="">
                        </div>
                        <div class="infographics-imgSec">
                          <picture class="w-100 d-block img-container">
                            <source [srcset]="infographic.filePath" media="(min-width: 768px)" class="w-100 deskImg">
                            <img decoding="async" [src]="infographic.filePath" [alt]="infographic.fileName"
                              class="w-100 mobImg img-fixed-height" loading="lazy">
                          </picture>
                        </div>
                        <div class="infoShare">
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="shareInfo">
                              <ul class="list-inline mb-0">
                                <li class="list-inline-item text-black f-s-14">
                                  Share
                                </li>
                                <li class="list-inline-item"
                                (click)="
                                  redirectToSocialMedia(
                                    1,
                                    infographic.filePath
                                  )
                                ">
                                  <a  href="javascript:void(0);" class="infoShare-icon">
                                    <img src="assets/ITI-IAP-HTML/images/infoshare-icon-1.svg" class="w-100" alt=""
                                      loading="lazy">
                                  </a>
                                </li>
                                <li class="list-inline-item"
                                (click)="
                                  redirectToSocialMedia(
                                    2,
                                    infographic.filePath
                                  )
                                ">
                                  <a href="javascript:void(0);" class="infoShare-icon">
                                    <img src="assets/ITI-IAP-HTML/images/infoshare-icon-2.svg" class="w-100" alt=""
                                      loading="lazy">
                                  </a>
                                </li>
                                <li class="list-inline-item"
                                (click)="
                                  redirectToSocialMedia(
                                    3,
                                    infographic.filePath
                                  )
                                ">
                                  <a  href="javascript:void(0);" class="infoShare-icon">
                                    <img src="assets/ITI-IAP-HTML/images/infoshare-icon-3.svg" class="w-100" alt=""
                                      loading="lazy">
                                  </a>
                                </li>
                                <li class="list-inline-item"
                                (click)="
                                  redirectToSocialMedia(
                                    4,
                                    infographic.filePath
                                  )
                                ">
                                  <a  href="javascript:void(0);" class="infoShare-icon">
                                    <img src="assets/ITI-IAP-HTML/images/infoshare-icon-4.svg" class="w-100" alt=""
                                      loading="lazy">
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div class="infoDownload">
                              <a href="javascript:void(0);" class="downloadBtn line_H_1 text-black f-s-14 d-flex cstgap-2" (click)="downloadFile(infographic.filePath)" >
                                Download <file-download [path]="infographic.filePath"></file-download>
                              </a>
                            </div>
                          </div>
                        </div>

                      </ng-template>
                    </div>
                  </div>
                  <div class="row row-vw">
                    <div class="col-lg-12">
                      <div class="viewAll_wrap mrg-t-50 text-center" (click)="viewAllBlogs()">
                        <a class="viewAll_btn f-s-20 font-Baskervville "> View All </a>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #noInfographicTemplate>
                  <p class="nodata">No Infographics found.</p>
                </ng-template>
              </div>

              <div class="tab-pane fade" id="read-tab-pane" role="tabpanel" aria-labelledby="read-tab" tabindex="0"
                *ngIf="activeTab === 'read'">
                <div class="accordion-body tabOverview_wrap"
                  *ngIf="blogList && blogList.length>0; else noArticleTemplate">
                  <div class="row row-vw blogs-row" #readRow>
                    <div class="col-lg-4" *ngFor="let blog of blogList">
                      <div class="watchBx" (click)="viewBlogPage(blog.id)">

                        <div class="yt-img position-relative mrg-b-15 cursor-pointer">
                          <picture class="w-100 d-block infographic">
                            <source [srcset]="blog.imagePath" media="(min-width: 768px)"
                              class="w-100 deskImg  thumbnail-img">
                            <img decoding="async" [src]="blog.imagePath" alt="" class="w-100 mobImg  thumbnail-img"
                              loading="lazy">
                          </picture>
                        </div>
                        <div
                          class="watchTitle f-s-20 font-Baskervville line_H_1_2 text-black text-decoration-underline cursor-pointer"style="text-align: center;">
                          {{ blog.title }}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="row row-vw">
                    <div class="col-lg-12">
                      <div class="viewAll_wrap mrg-t-50 text-center" (click)="viewAllBlogs()">
                        <a class="viewAll_btn f-s-20 font-Baskervville "> View All </a>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #noArticleTemplate>
                  <p class="nodata">No Articles found.</p>
                </ng-template>
              </div>

            </div>
           
            <!-- <div *ngIf="showArrow === true" class="arrow-img cursor-pointer" (click)="scrollRight()"> <img
                src="assets/ITI-IAP-HTML/images/chevron-right.svg" alt="" srcset="">
            </div> -->
            <div class="arrow-img cursor-pointer" [ngClass]="{ 'invisible': !showArrow }" (click)="scrollRight()"><img
                src="assets/ITI-IAP-HTML/images/chevron-right.svg" alt="" srcset="">
            </div>

        </div>

      </div>
    </div>
  </div>


  <div class="secWrap bgLight-gray" id="why-invest">
    <div class="full-container container lg-container-vw" *ngIf="organizedSections && organizedSections['Section2']">
      <div class="row row-vw justify-content-center">
        <div class="col-lg-12">
          <div class="secHeader text-center mrg-b-30">
            <div class="sectitle f-s-36 mrg-b-15"> {{  organizedSections['Section2']?.title }}
            </div>
            <div class="secSub-title">
              {{  organizedSections['Section1']?.description }}
            </div>
          </div>
        </div>
      </div>
      <div class="row row-vw-one">
        <div *ngFor="let subSection of organizedSections['Section2']?.subSections" class="col-lg-4">
          <div class="sip-bx trasn_1">
            <div class="sipIcon mx-auto mrg-b-10">
              <img [src]="subSection.iconPath" class="w-100" alt="" loading="lazy">
            </div>
            <div class="sipTxt-titlee f-s-24 text-black f-w-M text-center mrg-b-10">
              {{ subSection.title }}

            </div>
            <div class="txtSummary text-center f-s-16">
              {{ subSection.description }}
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>


  <div class="secWrap bgWrap" style="background-image: url(assets/ITI-IAP-HTML/images/sip-bg.jpg);"
    id="why-consistency" *ngIf="organizedSections && organizedSections['Section3']">
    <div class="full-container container lg-container-vw">
      <div class="row row-vw justify-content-center">
        <div class="col-lg-12">
          <div class="secHeader text-center mrg-b-30">
            <div class="sectitle f-s-36 mrg-b-15"> {{  organizedSections['Section3']?.title }}
            </div>
            <div class="secSub-title">
              {{  organizedSections['Section3']?.description }}
            </div>
          </div>
        </div>
      </div>
      <div class="row row-vw-one">
        <div *ngFor="let subSection of organizedSections['Section3']?.subSections" class="col-lg-4">
          <div class="sip-bx sip-bxMF trasn_1">
            <div class="sipIcon mx-auto mrg-b-10">
              <img [src]="subSection.iconPath" class="w-100" alt="" loading="lazy">
            </div>
            <div class="sipTxt-titlee f-s-24 text-black f-w-M text-center mrg-b-10"> {{ subSection.title }}</div>
            <div class="txtSummary text-center f-s-16 ">
              {{ subSection.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="secWrap mutualFund-form" id="know-more">
    <div class="full-container container lg-container-vw">
      <div class="row row-vw justify-content-center" *ngIf="organizedSections && organizedSections['Form']">
        <div class="col-lg-12">
          <div class="secHeader text-center mrg-b-30">
            <div class="sectitle f-s-36 mrg-b-15"> {{organizedSections['Form'].title}}
                </div>
            <div class="secSub-title">
              {{organizedSections['Form'].description}}
            </div>
          </div>
        </div>
      </div>
      <div class="row row-vw justify-content-center">
        <div class="col-lg-9">
          <div class="mf-form">
            <form #form="ngForm" (ngSubmit)="submitForm(form)" novalidate>
              <div class="row row-vw">
                <!-- Name Field -->
                <div class="col-lg-4">
                  <div class="formGroup mrg-b-30">
                    
                    <input
                      type="text"
                      name="name"
                      [(ngModel)]="formData.name"
                      placeholder="Your Name*"
                      class="cstInput f-s-14"
                      #name="ngModel"
                      required
                    />
                    <div
                      *ngIf="name.invalid && name.touched"
                      class="error-message"
                    >
                      Name is required.
                    </div>
                  </div>
                </div>

                <!-- Email Field -->
                <div class="col-lg-4">
                  <div class="formGroup mrg-b-30">
                   
                    <input
                      type="email"
                      name="emailId"
                      [(ngModel)]="formData.emailId"
                      placeholder="Email ID*"
                      class="cstInput f-s-14"
                      #email="ngModel"
                      required
                      pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                    />
                    <div
                      *ngIf="email.invalid && email.touched"
                      class="error-message"
                    >
                      <span *ngIf="email.errors?.required"
                        >Email is required.</span
                      >
                      <span *ngIf="email.errors?.pattern"
                        >Invalid email format.</span
                      >
                    </div>
                  </div>
                </div>

                <!-- Mobile Number Field -->
                <div class="col-lg-4">
                  <div class="formGroup mrg-b-30">
                    
                    <input
                      type="text"
                      name="mobileNumber"
                      [(ngModel)]="formData.mobileNumber"
                      placeholder="Mobile Number*"
                      class="cstInput f-s-14"
                      #mobile="ngModel"
                      required
                      pattern="[0-9]{10}"
                    />
                    <div
                      *ngIf="mobile.invalid && mobile.touched"
                      class="error-message"
                    >
                      <span *ngIf="mobile.errors?.required"
                        >Mobile number is required.</span
                      >
                      <span *ngIf="mobile.errors?.pattern"
                        >Enter a valid 10-digit number.</span
                      >
                    </div>
                  </div>
                </div>

                <!-- Comment Field -->
                <div class="col-lg-12">
                  <div class="formGroup mrg-b-30">
                    
                    <textarea
                      name="comment"
                      [(ngModel)]="formData.comment"
                      placeholder="What feature are you looking for?"
                      class="cstInput f-s-14"
                      rows="5"
                      #comment="ngModel"
                      required
                    ></textarea>
                    <div
                      *ngIf="comment.invalid && comment.touched"
                      class="error-message"
                    >
                      Comment is required.
                    </div>
                  </div>
                </div>

                <!-- Submit Button -->
                <div class="col-lg-12">
                  <div class="submitBtn text-center">
                    
                    <button
                      type="submit"
                      class="viewAll_btn f-s-20 ltr-space cursor-pointer"
                      [disabled]="form.invalid"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="secWrap">
    <div class="full-container container lg-container-vw">
      <div class="row row-vw justify-content-center"  *ngIf="organizedSections && organizedSections['Disclaimer']">
        <div class="col-lg-12">
          <div class="secHeader mrg-b-30">
            <div class="sectitle f-s-20 mrg-b-5  f-w-SB font-poppins"> {{organizedSections['Disclaimer'].title}} </div>
            <div class="secSub-title knowMore-info font-poppins" [innerHTML]="organizedSections['Disclaimer'].description">
       
            </div>
          </div>
        </div>
      </div>
      <div class="mrg-b-30">
        <div class="row row-vw">
          <div class="col-lg-12">
            <div class="d-md-flex align-items-center justify-content-center cstgap-3">
              <div class="contactSec" *ngIf="organizedSections && organizedSections['Disclaimer']">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item">
                    <a href="mailto:mfassist@itiorg.com" class="d-flex align-items-center primary-clr">
                      <div class="mailIcon mrg-r-15"> <img src="assets/ITI-IAP-HTML/images/mail-icon.svg" class="w-100"
                          alt=""> </div>
                      <div class="mailTxt f-s-20  primary-clr font-Baskervville"> {{ organizedSections['Disclaimer'].email}} </div>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="tel:18002669603" class="d-flex align-items-center primary-clr">
                      <div class="mailIcon mrg-r-15"> <img src="assets/ITI-IAP-HTML/images/phone-icon.svg" class="w-100"
                          alt=""> </div>
                      <div class="mailTxt f-s-20  primary-clr font-Baskervville"> {{ organizedSections['Disclaimer'].mobile}} </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="followUs_sec">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item font-Baskervville">
                    Follow Us On:
                  </li>
                  <li class="list-inline-item">
                    <a href="https://www.youtube.com/channel/UCpWl987-i9dvbfiTOLQIleQ" target="_blank"
                      class="socialIcon">
                      <img src="assets/ITI-IAP-HTML/images/yt.svg" class="w-100" alt="" loading="lazy">
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="https://www.instagram.com/iti.mutualfund/" target="_blank" class="socialIcon">
                      <img src="assets/ITI-IAP-HTML/images/insta.svg" class="w-100" alt="" loading="lazy">
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="https://www.facebook.com/ITIMutualFund/" target="_blank" class="socialIcon">
                      <img src="assets/ITI-IAP-HTML/images/fb.svg" class="w-100" alt="" loading="lazy">
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="https://x.com/itimutualfund" target="_blank" class="socialIcon">
                      <img src="assets/ITI-IAP-HTML/images/twt.svg" class="w-100" alt="" loading="lazy">
                    </a>
                  </li>               
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-vw" *ngIf= "organizedSections && organizedSections['Disclaimer']" >
        <div class="col-lg-12">
          <div class="font-poppins f-w-M  text-center" > {{organizedSections['Disclaimer'].disclaimerAdditionalText}} </div>
        </div>
      </div>
    </div>
  </div>


  <div class="footer overflow-hidden">
    <div class="full-container container lg-container-vw">
      <div class="row row-vw">
        <div class="col-lg-12">
          <div class="copyright f-s-16 font-Baskervville  text-center text-white"> © 2024 ITI Mutual Fund.
            All rights reserved </div>
        </div>
      </div>
    </div>
  </div>




  <div class="modal fade thankyou-modal" id="thankyou-modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="closeBtn">
            <a href="javascript:void(0)" class="btn-close" data-bs-dismiss="modal">
              <img src="assets/ITI-IAP-HTML/images/black-close-circle-or-delete-20709.svg" alt="" srcset=""> </a>
          </div>
          <div class="thankModal_wrap text-center">
            <div class="f-s-64 tick-icon"> <i class="fa-regular fa-circle-check"></i> </div>
            <div class="thankyou-txt f-s-20"> Your submission is received and we will contact you soon </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- Video Modal -->
<div class="video-modal" *ngIf="showVideoPopup" (click)="closeVideo()">
  <div class="video-popup-content" 
       [ngClass]="{'full-video': !isShort, 'short-video': isShort}" 
       (click)="$event.stopPropagation()">

    <!-- Spinner -->
    <div *ngIf="loadingVideo" class="video-loading-overlay">
      <div class="spinner"></div>
    </div>

    <div class="video-responsive-wrapper">
      <youtube-player
        [videoId]="videoId"
        (ready)="onPlayerReady($event)">
      </youtube-player>
    </div>

    <button class="close-btn" (click)="closeVideo()">✕</button>
  </div>
</div>


  
</div>